export default __webpack_public_path__ + "f101b0f7aaac81d089b19d01d8ae8cb3.jpg";